import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { ExperienceController } from './controllers/Experience';
import { Landing } from './controllers/Landing';
import { Edition } from './controllers/Edition';
import { Preview } from './controllers/Preview';
import { Collect } from './controllers/SmartOptinsCollect';
import { init as initDatadog } from './utils/datadog';

initDatadog();

const App: React.FunctionComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* i.e. http://localhost:3008/?shopperId=toto_1&siteKey=y4hnl2U6&cartId=cartId */}
        <Route path="/" element={<ExperienceController />} />
        {/* i.e. http://localhost:3008/landing?ticketCode=FUXT-LMCZ-WSIY-JGAV&siteKey=OZckQZty&customerUid=yanisbreton */}
        <Route path="/landing" element={<Landing />} />
        {/* i.e. http://localhost:3002/edition */}
        <Route path="/edition/:screenType" element={<Edition />} />
        {/* i.e. http://localhost:3002/preview/628e1dec2323922d99c321dd */}
        <Route path="/preview/:operationId" element={<Preview />} />
        {/* i.e. http://localhost:3002/collect */}
        <Route path="/collect" element={<Collect />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
